import { setDefaultOptions } from 'date-fns';
import { lt } from 'date-fns/locale/lt';
import { registerLocale } from 'react-datepicker';
registerLocale('lt', lt);

export const enableLanguage = (lang: 'en' | 'lt') => {
  const locale = lang === 'en' ? undefined : lt;
  setDefaultOptions({ locale });
};
